import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=020c1f7e&scoped=true&"
import script from "./Alert.vue?vue&type=script&lang=js&"
export * from "./Alert.vue?vue&type=script&lang=js&"
import style0 from "./Alert.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Alert.vue?vue&type=style&index=1&id=020c1f7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020c1f7e",
  null
  
)

export default component.exports